// extracted by css-extract-rspack-plugin
export default {"TableSearchContainer":"Tfgtu","TriggerContainer":"gpQzb","TriggerContainerIcon":"vyPtZ","TextSchema":"oKqFr","BackButtonLabel":"CIye_"};